import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpRequestHelper } from 'app/helpers/httpRequestHelper';
import { ListBakvordurInOutStatusRes } from 'app/interfaces/responses/List/listBakvordurInOutStatusRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BakvordurService {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(private http: HttpClient) { }

    public getBakvordurInOutStatus(): Observable<HttpStatus<ListBakvordurInOutStatusRes[]>> {
        return this.http.post<HttpStatus<ListBakvordurInOutStatusRes[]>>(
            environment.localApi + 'bakvordur/bakvordurInOutStatus',
            null,
            this.httpRequestHelper.getRequestOptionsAuth()
        );
    }

    public getBakvordurInOutStatusCount(): Observable<HttpStatus<number>> {
        return this.http.post<HttpStatus<number>>(
            environment.localApi + 'bakvordur/bakvordurInOutStatusCount',
            null,
            this.httpRequestHelper.getRequestOptionsAuth()
        );
    }
}